import multiFontFamily from './multiFontFamily';

export default multiFontFamily;
